import { render, staticRenderFns } from "./Bundle.vue?vue&type=template&id=a3fea3ae&scoped=true&"
import script from "./Bundle.vue?vue&type=script&lang=js&"
export * from "./Bundle.vue?vue&type=script&lang=js&"
import style0 from "./Bundle.vue?vue&type=style&index=0&id=a3fea3ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fea3ae",
  null
  
)

export default component.exports